module.exports = __webpack_public_path__ + "fonts/MyriadPro-SemiboldIt.9b86470.woff2";